var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMediumIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#000",
  rx: 17
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.604 17.323c0 3.933-3.161 7.122-7.06 7.122-3.9 0-7.062-3.19-7.062-7.122S7.643 10.2 11.543 10.2s7.06 3.189 7.06 7.123M26.35 17.323c0 3.702-1.58 6.705-3.53 6.705s-3.53-3.003-3.53-6.705 1.58-6.706 3.53-6.706 3.53 3.002 3.53 6.706M29.518 17.323c0 3.316-.556 6.006-1.241 6.006-.686 0-1.242-2.69-1.242-6.006 0-3.318.556-6.007 1.242-6.007s1.241 2.689 1.241 6.007"
}))));
export default SvgMediumIcon;